const statusDatas = {
  DEFINITIVO: { id: 1, label: "Definitivo" },
  //No caso de crm usar esse status se precisar e no futuro 
  // verificar necessidade para criar um enum que retorna status diferentes de acordo com o modelo
  // isso quando eles forem pouco diferentes ou fazer um enum para cada modelo
  // EMITIDO: { id: 1, label: "Emitido" },
  NORMAL: { id: 2, label: "Normal" },
  PROXIMO_DO_VENCIMENTO: { id: 3, label: "Proximo Do Vencimento" },
  VENCIDO: { id: 4, label: "Vencido" },
  PREVISAO: { id: 5, label: "Previsão" },
  SOLICITACAO: { id: 6, label: "Solicitação" },

};

const listaStatus = [
  { id: "todos", label: "todos" },
  { id: 1, label: "Definitivo" },
  { id: 3, label: "Proximo Do Vencimento" },
  { id: 2, label: "Normal" },
  { id: 4, label: "Vencido" },
  { id: 5, label: "Previsão" },
  { id: 6, label: "Solicitação" },
];

export { statusDatas, listaStatus };
